import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SelectItem } from 'primeng/primeng';
import { AddTOSIPRequest } from '../../models/ss-api/requests/add.tos.ip.request';
import { TOSIPTypes } from '../../models/domain/tos.ip';
import { addTOSMacRequest } from '../../models/ss-api/requests/add.tos.mac.request';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

export interface ITOSSettingItemDialogModel {
    title: string;
    subTitle: string;
    isEdit: boolean;
    settingID?: number;
    MemberID: number;
}

@Component({
    selector: 'tos-setting-item-dialog',
    styleUrls: ['./tos.setting.item.dialog.css'],
    templateUrl: './tos.setting.item.dialog.html'
})
export class TOSSettingItemDialog extends DialogComponent<ITOSSettingItemDialogModel, boolean> implements ITOSSettingItemDialogModel, OnInit {

    title: string;
    subTitle: string;

    isEdit: boolean = false;

    settingID: number = -1;

    MemberID: number;

    // VARIABLES
    IPAddress: string = '';
    PCName: string = 'pc';

    TypeOptions: SelectItem[] = [];
    SelectedType: string = 'IP';

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, private gb: GlobalService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.SetUpTypeOptions();
    }

    SetUpTypeOptions() {
        this.TypeOptions.push({ label: 'IP Address', value: 'IP' });
        this.TypeOptions.push({ label: 'MAC Address', value: 'MAC' });
    }


    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        let IPrequest = new AddTOSIPRequest;
        IPrequest.IP = this.IPAddress;
        IPrequest.IPType = TOSIPTypes.Blacklist;
        IPrequest.AdminID = this.gb.AdminId;
        IPrequest.MemberID = this.MemberID;


        let MACrequest = new addTOSMacRequest;
        MACrequest.MacAddress = this.IPAddress;
        MACrequest.AdminID = this.gb.AdminId;
        MACrequest.MemberID = this.MemberID;


        await this.sweetAlertService.swal(
            {
                title: 'Add TOS Setting?',
                text: 'Are you sure you want to add this TOS Setting?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, add setting!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                preConfirm: () => {
                    if (this.SelectedType == 'IP') {
                        return this.api.AddTOSFlaggedIP(IPrequest).toPromise();
                    } else if (this.SelectedType == 'MAC') {
                        return this.api.AddTOSFlaggedMac(MACrequest).toPromise();
                    }

                }
            })
            .then(async (response: any) => {
                this.result = true;
                this.close();
                this.sweetAlertService.swal(
                    {
                        title: 'Setting Added',
                        text: 'Shout \'HOORAY!\'',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {

                    }, (dismiss) => {

                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        this.close();
                    }, (dismiss) => {
                        return;
                    }); // keep this line to prevent promise error;
            });



    }


}
